module.exports = __webpack_public_path__ + "static/media/Template_23.7150f51e.png";